import { ComponentType, memo, useEffect } from 'react';

import { bootstrapBigPicture } from '@vimeo/core/libs/tracking';
import { useViewer } from '@vimeo/viewer';

/** Should be wrapped inside withViewer HOC */
export const withAnalytics = (Component: ComponentType) => {
  return memo((props: any) => {
    const viewer = useViewer();

    /** Initialised bp package at loadtime */
    useEffect(() => {
      bootstrapBigPicture(viewer);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <Component {...props} />;
  });
};
